import { render, staticRenderFns } from "./RightOption.vue?vue&type=template&id=1d68537f&scoped=true&"
import script from "./RightOption.vue?vue&type=script&lang=js&"
export * from "./RightOption.vue?vue&type=script&lang=js&"
import style0 from "./RightOption.vue?vue&type=style&index=0&id=1d68537f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d68537f",
  null
  
)

export default component.exports